import { render, staticRenderFns } from "./ContragentsTable.vue?vue&type=template&id=ed876e6c&scoped=true&"
import script from "./ContragentsTable.vue?vue&type=script&lang=js&"
export * from "./ContragentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContragentsTable.vue?vue&type=style&index=0&id=ed876e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed876e6c",
  null
  
)

export default component.exports